import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { wstepy } from '../../../functions/motions';
import { dataFormatMsc, nextMonth, pierwszyDzienMiesiaca } from "../../../functions/dataFormat.js";
import { getTablicaPrzelewy2, getTablicaCzynsze2 } from "../../../functions/tablice.js";
import WspolnotaRozliczenieDane from "./WspolnotaRozliczenieDane.js";
import WspolnotaRozliczenieSeryjne from "./Seryjne/WspolnotaRozliczenieSeryjne.js";
import WspolnotaRozliczenieZaleglosci from "./Zaległości/WspolnotaRozliczenieZaleglosci.js";
import WspolnotaRozliczenieHistoria from "./Zaległości/WspolnotaRozliczenieHistoria.js";
import Loader from "../../Loader.js";

import { 
  fetchWspolnota, 
  fetchMieszkancy, 
  fetchMieszkancyAll,
  fetchPrzelewy, 
  fetchLokale, 
  fetchUlice, 
  fetchStawki, 
  fetchStawkiInd,
  fetchGrupy, 
  fetchGrupyAll,
  fetchUdzialyKonta,
  fetchUdzialyKontaAkt,
  fetchUsers,
  fetchPlanowaneZuzycie,
  fetchStawkiJednorazoweInd,
  fetchZaleglosciPowiadomienia
} from '../../../Redux/Actions.js'; 

import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';

const WspolnotaRozliczenie = () => {

  const queryParams = new URLSearchParams(window.location.search)
  const idw = queryParams.get("id");

  const dispatch = useDispatch();
  
  const wspolnotaArr = useSelector( state  => state?.wspolnota?.data);
  const mieszkancy = useSelector( state => state?.mieszkancy?.data);

  const lokale = useSelector( state => state?.lokale?.data);
  const ulice = useSelector( state => state?.ulice?.data);
  const grupy = useSelector( state => state?.grupy?.data);
  const udzialyKonta = useSelector( state => state?.udzialyKonta?.data);
  const udzialyKontaAkt = useSelector( state => state?.udzialyKontaAkt?.data);
  const przelewy = useSelector( state => state?.przelewy?.data);
  const stawki = useSelector( state => state?.stawki?.data);
  const stawkiJednorazowe = []; 
  const planowaneZuzycie = useSelector( state => state?.planowaneZuzycie?.data);
  const stawkiInd = useSelector( state => state?.stawkiInd?.data );
  const stawkiJednorazoweInd = useSelector( state => state?.stawkiJednorazoweInd?.data);
  const zaleglosciPowiadomienia = useSelector( state => state?.zaleglosciPowiadomienia?.data);

  const [wspolnota, setWspolnota] = useState([]);
  const [czynszeMsc, setCzynszeMsc] = useState(undefined);
  const [czynszeWspolnota, setCzynszeWspolnota] = useState(undefined);
  const [przelewyWspolnota, setPrzelewyWspolnota] = useState(undefined);
  const [miesiac, setMiesiac] = useState(dataFormatMsc(new Date()));
  const [listaMsc, setListaMsc] = useState(undefined); 
  const [ind, setInd] = useState(undefined); 
  const [loaderOn, setLoaderOn] = useState(true);

  useEffect( ()=> {
    dispatch(fetchWspolnota(idw)); 
    dispatch(fetchMieszkancy(idw)); 
    dispatch(fetchUsers(idw));
    dispatch(fetchMieszkancyAll(idw));
    dispatch(fetchPrzelewy(idw)); 
    dispatch(fetchLokale(idw)); 
    dispatch(fetchUlice(idw)); 
    dispatch(fetchStawki(idw)); 
    dispatch(fetchStawkiInd(idw));
    dispatch(fetchStawkiJednorazoweInd(idw));
    dispatch(fetchGrupy(idw)); 
    dispatch(fetchGrupyAll(idw)); 
    dispatch(fetchUdzialyKonta(idw));
    dispatch(fetchUdzialyKontaAkt(idw));
    dispatch(fetchPlanowaneZuzycie(idw));
    dispatch(fetchZaleglosciPowiadomienia(idw));
  },[dispatch, idw]);
  
  useEffect(() => setWspolnota( wspolnotaArr?.find( w => w.id == idw) ), [wspolnotaArr, idw])
  
  
  const dodajMiesiac = d => {
    d.setMonth(d.getMonth() + 1);
    return d;
  };

  useEffect( () => { 
    const temp2  = [];
    czynszeWspolnota?.forEach( czynsz => {
      czynsz?.grupy_udzial_msc?.forEach( c => {
        const temp = c.temp_msc?.filter( t => t.msc == miesiac)
        if (temp && temp.length > 0) {
          const tempCzynszMsc = czynszeWspolnota?.find( cz => cz?.id_user == czynsz?.id_user && cz?.grupa_numer == czynsz?.grupa_numer)?.grupy_msc?.find( cc => cc?.grupa_numer == c.grupa_numer);
  
          temp2.push(     
            {
              id_user: czynsz.id_user,
              grupa_numer: c.grupa_numer,
              czynsz: temp[0],
              ind: tempCzynszMsc ? tempCzynszMsc?.temp_msc?.find( t => t?.msc == miesiac)?.jednorazoweIndTab : []
            }
          )
        }
      });
    });

    const uniqueOpisSet = new Set();
    temp2?.forEach(obj => {
      if (Array.isArray(obj.ind)) {
          obj.ind.forEach(item => {
              if (item.opis) {
                  uniqueOpisSet.add(item.opis);
              }
          });
      }
    });
    setInd(Array.from(uniqueOpisSet))

    setCzynszeMsc(temp2)
  },[czynszeWspolnota, miesiac])

  useEffect(()=> {
    if (stawki?.length > 0) {

      let minData1 = stawki[0].data_od
      let minData2 = stawki[0].data_od;
      
      if (stawkiJednorazoweInd?.length > 0 ) {
        minData2 = pierwszyDzienMiesiaca(new Date(stawkiJednorazoweInd[0].msc));
      } 

      let minData = new Date(minData1) <= new Date(minData2) ? minData1 : minData2;

      for (let i = 1; i < stawki.length; i++) {
        if (stawki[i].data_od < minData) {
          minData = stawki[i].data_od;
        }
      }

      const dataObecna = new Date();
      const dataMiesiacPoObecnej = nextMonth(new Date(dataObecna));
  
      const tablicaMiesiecy = [];
      let aktualnaData = new Date(minData);
      while (aktualnaData <= dataMiesiacPoObecnej) {
        tablicaMiesiecy.push(dataFormatMsc(aktualnaData));
        aktualnaData = dodajMiesiac(aktualnaData);
      }
      if (tablicaMiesiecy) {
        setMiesiac(tablicaMiesiecy[tablicaMiesiecy?.length-1])
      }
      setListaMsc(tablicaMiesiecy)
    }
  },[stawki]);


  useEffect( () => {
    const temp = getTablicaCzynsze2(wspolnotaArr, mieszkancy, grupy, [],udzialyKonta, udzialyKontaAkt, lokale, stawki, planowaneZuzycie, stawkiJednorazowe, stawkiInd, stawkiJednorazoweInd /*, zaliczki */)[0];
    setCzynszeWspolnota(temp?.grupy);
  },[wspolnotaArr, mieszkancy, grupy, udzialyKonta, udzialyKontaAkt, lokale, stawki, planowaneZuzycie, stawkiInd, stawkiJednorazoweInd /*, zaliczki */])

  useEffect( () =>{
    const temp = getTablicaPrzelewy2(wspolnotaArr, udzialyKontaAkt, przelewy)[0];
    if (temp?.length > 0) 
      setPrzelewyWspolnota(temp[0].grupy)
  },[wspolnotaArr, udzialyKontaAkt, przelewy])

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
      </div>
    );
  }
  
  CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };
  
  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  useEffect( () => czynszeWspolnota && przelewyWspolnota ? setLoaderOn(false) : setLoaderOn(true), [czynszeWspolnota, przelewyWspolnota]);
  
  return (
    <div 
      className="content wspolnotaRozliczenie"
      variants={wstepy}
      initial="initial"
      animate="animate"
    >
      
        <h1 className="nazwa">
          Należności wspólnoty 
        </h1>
        <h3>
          { wspolnota?.name }
        </h3>
        <div className="container">

          <Box sx={{ borderBottom: 1, borderColor: 'none' }}>
            <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
              <Tab label="Należności" {...a11yProps(0)} />
              <Tab label="Należności - wydruk seryjny" {...a11yProps(1)} />
              <Tab label="Zaległości - stan i wysyłka" {...a11yProps(2)} />
              <Tab label="Zaległości - historia powiadomień" {...a11yProps(3)} />
            </Tabs>
          </Box>
          <CustomTabPanel value={value} index={0}>
            <WspolnotaRozliczenieDane
              idw={idw}
              wspolnota={wspolnota}
              mieszkancy={mieszkancy}
              lokale={lokale}
              ulice={ulice}
              grupy={grupy}
              udzialyKontaAkt={udzialyKontaAkt}
              stawki={stawki}
              stawkiJednorazowe={stawkiJednorazowe}
              stawkiJednorazoweInd={stawkiJednorazoweInd}
              czynszeMsc={czynszeMsc}
              czynszeWspolnota={czynszeWspolnota}
              przelewyWspolnota={przelewyWspolnota}
              miesiac={miesiac}
              setMiesiac={setMiesiac}
              listaMsc={listaMsc}
              ind={ind}
            />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <WspolnotaRozliczenieSeryjne
              idw={idw}
              wspolnota={wspolnota}
              mieszkancy={mieszkancy}
              lokale={lokale}
              ulice={ulice}
              grupy={grupy}
              udzialyKontaAkt={udzialyKontaAkt}
              stawki={stawki}
              stawkiJednorazowe={stawkiJednorazowe}
              stawkiJednorazoweInd={stawkiJednorazoweInd}
              czynszeMsc={czynszeMsc}
              czynszeWspolnota={czynszeWspolnota}
              przelewyWspolnota={przelewyWspolnota}
              miesiac={miesiac}
              setMiesiac={setMiesiac}
              listaMsc={listaMsc}
              ind={ind}
            />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={2}>
            <WspolnotaRozliczenieZaleglosci
              wspolnota={wspolnota}
              czynszeMsc={czynszeMsc}
              idw={idw}
              udzialyKontaAkt={udzialyKontaAkt}
              przelewyWspolnota={przelewyWspolnota}
              czynszeWspolnota={czynszeWspolnota}
              mieszkancy={mieszkancy}
              ulice={ulice}
              lokale={lokale}
              grupy={grupy}
              zaleglosciPowiadomienia={zaleglosciPowiadomienia}
            />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={3}>
            <WspolnotaRozliczenieHistoria
              udzialyKontaAkt={udzialyKontaAkt}
              mieszkancy={mieszkancy}
              ulice={ulice}
              lokale={lokale}
              grupy={grupy}
              zaleglosciPowiadomienia={zaleglosciPowiadomienia}
            />
          </CustomTabPanel>
          
        </div>
        <Loader stan={loaderOn} />
    </div>
  )
}

export default WspolnotaRozliczenie; 